import { render, staticRenderFns } from "./MinhaUnimed.vue?vue&type=template&id=6d4d1eca"
import script from "./MinhaUnimed.vue?vue&type=script&lang=js"
export * from "./MinhaUnimed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports